import { css } from "./SKT";

export const SKTAction = ({ children, onClick, active, actionLabel, type }) => {
  const btnClass = type ?? "button-orange-24";

  const onClickEatEvent = (event) => {
    event.preventDefault();
    onClick();
    return false;
  };

  return (
    <div className={css("row")}>
      <div className={css("col-12 col-lg-8 font-13")}>{children}</div>

      <div className={css("col-12 col-lg-4 skt-move-to-right")}>
        <button
          className={css(btnClass)}
          onClick={onClickEatEvent}
          disabled={!active}
        >
          {actionLabel}
        </button>
      </div>
    </div>
  );
};
